import styled from 'styled-components';
import StepWizard from 'react-step-wizard';
import variables from '../../theme/variables';
import { StyledButton } from '../Button/Button';
import TrainerStyles from '../Trainer/styled';

const Form = styled(StepWizard)`
  height: 100%;
  overflow: hidden;
  min-height: -webkit-fill-available;

  > div {
    height: 100%;

    > div {
      height: 100%;
    }
  }
`;

const Step = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  p {
    font-size: 1.1.rem;
    font-weight: 600;
  }
`;

const StepContent = styled.div`
  flex: 1;
  flex-shrink: 0;
  overflow-y: auto;
`;

const ButtonsGroup = styled.div`
  height: 100%;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;

  ${StyledButton} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 400px;
    margin-bottom: ${variables.SPACING * 2}px;
    position: relative;

    img {
      position: absolute;
      right: ${variables.SPACING * 2}px;
      width: 40px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    @media (max-width: 450px) {
      min-width: 250px;
    }
  }
`;

const Cards = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 40px;
  max-width: 800px;
  margin: auto;
  justify-content: center;
`;

const Card = styled.div`
  background: #0a1118;
  color: white;
  padding: 16px;
  border-radius: 5px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const CardTitle = styled.div`
  text-align: left;
  margin-bottom: 16px;
  font-weight: 600;
`;
const CardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;

  img {
    width: 40px;
  }
`;

const Decks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 50px 0px;

  > * {
    flex-shrink: 0;
  }
`;

const Submit = styled.div`
  text-align: center;

  button {
    width: 80%;
  }
`;

const ConfigForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
  justify-content: center;
`;

const FormStyles = {
  Form,
  Step,
  StepContent,
  ButtonsGroup,
  Cards,
  Card,
  CardTitle,
  CardContent,
  Submit,
  Decks,
  ConfigForm,
};

export default FormStyles;
